module.exports = __webpack_public_path__ + "static/img/order-bg.d12a71bb.png";